<template>
  <div>
    <CRow>
      <CCol col="12" md="12" lg="12">
        <h4><strong>Data Riwayat Pendidikan</strong></h4>
        <hr />
      </CCol>
    </CRow>

    <CRow>
      <CCol col="12" md="12" lg="12">
        <b-button variant="primary" v-b-modal.modal-input-pendidikan><CIcon name="cil-plus" /> Tambah Data</b-button>
      </CCol>
    </CRow>

    <CRow class="mt-3">
      <CCol col="12" md="12" lg="12">
        <CDataTable :items="items" :fields="fields" responsive sorter hover show-empty :loading="tableBusy">
          <template #actions="{ item }">
            <td>
              <!-- <b-button
                variant="warning"
                class="mr-1"
                v-c-tooltip.hover.click="$store.state.table.tooltipEdit"
                v-b-modal.modal-edit-pendidikan
                @click="dataPendidikan = item"
              >
                <CIcon name="cil-pencil" />
              </b-button> -->
              <b-button variant="danger" class="mr-1" v-c-tooltip.hover.click="$store.state.table.tooltipHapus" v-b-modal.modal-delete-pendidikan @click="dataPendidikan = item">
                <CIcon name="cil-trash" />
              </b-button>
            </td>
          </template>
        </CDataTable>
      </CCol>
    </CRow>

    <modal-input :data="data" @alertFromChild="triggerAlert($event)" />
    <modal-edit :dataPendidikan="dataPendidikan" @alertFromChild="triggerAlert($event)" />
    <modal-delete :dataPendidikan="dataPendidikan" @alertFromChild="triggerAlert($event)" />
  </div>
</template>
<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";
export default {
  props: ["data", "activeTab"],
  components: {
    modalInput,
    modalEdit,
    modalDelete,
  },
  data() {
    return {
      items: [],
      dataPendidikan: "",
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          class: "table-number text-center",
        },
        {
          key: "tingkatPendidikan",
          label: "Tingkat Pendidikan",
          sortDirection: "desc",
          _style: "width: 15%;",
          class: "text-left",
          filter: false,
        },
        {
          key: "namaSekolah",
          label: "Nama Sekolah",
          sortDirection: "desc",
          _style: "width: 40%;",
          class: "text-left",
          filter: false,
        },
        {
          key: "tahunLulus",
          label: "Tahun Kelulusan",
          sortDirection: "desc",
          _style: "width: 15%;",
          class: "text-left",
          filter: false,
        },
        {
          key: "jurusan",
          label: "Jurusan",
          sortDirection: "desc",
          _style: "width: 15%;",
          class: "text-left",
          filter: false,
        },
        {
          key: "actions",
          label: "Actions",
          sortDirection: "desc",
          _style: "width: 15%;",
          class: "table-option-3 text-center",
          filter: false,
          sorter: false,
        },
      ],
      tableBusy: false,
    };
  },
  computed: {},
  watch: {
    "data.dataKaryawanId"(newVar, oldVar) {
      if (newVar != oldVar) {
        this.getPengalamanPendidikan();
      }
    },
    activeTab(newVal) {
      if (newVal === 2) {
        this.getPengalamanPendidikan();
      }
    },
  },
  mounted() {},
  methods: {
    async getPengalamanPendidikan() {
      let vm = this;
      vm.items = [];
      let listPengpen = await vm.$axios.get("dataKaryawan/detailsByDataKaryawanId/" + vm.$route.query.dataKaryawanId);
      // console.log('listPengpen', listPengpen);
      vm.items =
        listPengpen.data.status == 200 && listPengpen.data.data.length > 0
          ? listPengpen.data.data[0].riwayatPendidikan.map((x, idx) => {
              return {
                ...x,
                no: idx + 1,
              };
            })
          : [];
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.$emit("update");
      vm.getPengalamanPendidikan();
    },
  },
};
</script>
